/** Normalizes same-origin document.referrer to pathname only so BI Origin stays path-like (e.g. /hire) and never leaks external URLs or query strings. */
export function getSafeBiReferrerOrigin({
  referrer,
  currentOrigin,
}: {
  referrer?: string;
  currentOrigin?: string;
}): string | undefined {
  if (!referrer || !currentOrigin) {
    return undefined;
  }

  try {
    const referrerUrl = new URL(referrer);

    if (referrerUrl.origin !== currentOrigin) {
      return undefined;
    }

    return referrerUrl.pathname || '/';
  } catch {
    return undefined;
  }
}

export function getSafeBiOrigin(origin?: string): string | undefined {
  if (origin) {
    return origin;
  }

  if (typeof window === 'undefined') {
    return undefined;
  }

  return getSafeBiReferrerOrigin({
    referrer: document.referrer,
    currentOrigin: window.location.origin,
  });
}
